import { useSearchParams } from "react-router-dom";

const getSelectedValues = (value) =>
  new Set(
    (value ?? "")
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean)
  );

const useDashboardExplorerCriteria = ({
  typeCriteriaKey,
  statusCriteriaKey,
  additionalCriteriaSearchParamMap = {},
}) => {
  const [searchParams] = useSearchParams();
  const criteriaSearchParamMap = {
    [typeCriteriaKey]: "typeId",
    [statusCriteriaKey]: "statusId",
    ...additionalCriteriaSearchParamMap,
  };
  const initialCriteriaSelectionMap = Object.fromEntries(
    Object.entries(criteriaSearchParamMap)
      .map(([criteriaKey, searchParam]) => [
        criteriaKey,
        getSelectedValues(searchParams.get(searchParam)),
      ])
      .filter(([, selectedValues]) => selectedValues.size > 0)
  );

  if (Object.keys(initialCriteriaSelectionMap).length === 0) {
    return {};
  }

  return {
    initialCriteriaSelectionMap,
    skipSavedCriteria: true,
    criteriaSearchParamMap,
  };
};

export default useDashboardExplorerCriteria;
